// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.division-line {
  vertical-align: middle;
  width: 45%;
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/components/LoginForm/LoginForm.scss"],"names":[],"mappings":"AAEA;EACI,sBAAA;EACA,UAAA;EACA,qBAAA;AADJ","sourcesContent":["@import \"./../../utils/scss/variables\";\n\n.division-line{\n    vertical-align: middle;\n    width: 45%;\n    display: inline-block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
